import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class Permission {
  async init() {
    return (await fetchApi.get(`/permission`)).data;
  }
}
